<div style="display: flex; width: 100%">
    <div *ngFor="let event of events" class="step">
        <svg width="10" height="10">
            <circle cx="5" cy="5" r="5" stroke="black" stroke-width="0" [attr.fill]="event.done?'blue':'grey'" />
        </svg>
        <div style="text-align: center; font-size: 8px">{{ event.title }}</div>
    </div>
</div>